import { EventTypes, PageSource } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import { useStaticData } from '@mc/static-data-react'

import BusinessBanner from 'components/BusinessBanner/BusinessBanner'
import { ClassSampleEmailCapture } from 'components/EmailCapture'
import { FAQ } from 'components/FAQ'
import { Subscription } from 'components/Subscription'
import { CourseMeta, OutcomeContent } from 'types/data'

import { SubcatCoursesSection } from './SubcatCoursesSection'
import { OutcomeContentList } from './OutcomeContentList'
import { useOutcomePageEvents } from '../utils'

export const BelowTheFold = () => {
  const { outcomeRankedContent, courseSlugToMeta } = useStaticData<{
    courseSlugToMeta: Record<string, CourseMeta>
    outcomeRankedContent: OutcomeContent[]
  }>()

  const { trackComponentViewed, getPageCategoryInfo } = useOutcomePageEvents()

  return (
    <>
      <TrackingContainer
        className='mc-mb-9'
        onFirstVisible={() => trackComponentViewed('outcome_content')}
      >
        <OutcomeContentList
          content={outcomeRankedContent.slice(3)}
          courseMeta={courseSlugToMeta}
        />
      </TrackingContainer>

      <TrackingContainer
        onFirstVisible={() => trackComponentViewed('other_classes')}
      >
        <SubcatCoursesSection />
      </TrackingContainer>

      <ClassSampleEmailCapture
        trackProps={{
          trackLocation: 'outcome_page_body_slim_banner',
          contentType: 'home',
        }}
      />
      <TrackingContainer
        onFirstVisible={() => trackComponentViewed('whats_included')}
      >
        <Subscription eventProps={getPageCategoryInfo()} />
      </TrackingContainer>
      <TrackingContainer onFirstVisible={() => trackComponentViewed('faq')}>
        <FAQ
          className='container mc-my-12'
          eventType={EventTypes.OUTCOME_PAGE_CLICK}
          pageSource={PageSource.OUTCOME}
          eventLocation='faq-section'
        />
      </TrackingContainer>

      <BusinessBanner pageSource={PageSource.OUTCOME} />
    </>
  )
}
